export default __webpack_public_path__ + "static/media/lb-mailer.d6dd582b.svg";